import Routes, { SECURITY_PATH } from "routing/Routes";
import SecurityPageEntry from "components/security/SecurityPageEntry";
import DEFAULT_ENTERPRISE_NAV_ITEM from "components/navigation/DefaultEnterpriseNavItem";
const routes = [{ path: `${SECURITY_PATH}/*`, component: SecurityPageEntry }];
export const DEFAULT_SECURITY_NAV_ITEM = {
  description: "Security",
  position: { after: DEFAULT_ENTERPRISE_NAV_ITEM.description },
  children: [
    { path: Routes.SECURITY.OVERVIEW, description: "Overview" },
    { path: Routes.SECURITY.USER_ACTIVITY, description: "User Activity" },
    { path: Routes.SECURITY.HOST_ACTIVITY, description: "Host Activity" },
    { path: Routes.SECURITY.NETWORK_ACTIVITY, description: "Network Activity" },
    { path: Routes.SECURITY.ANOMALIES, description: "Anomalies" }
  ]
};
const pluginExports = {
  routes
};
export default pluginExports;
